var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, Icon, VErrorIcon } from '@springcare/sh-component-library';
export var UnkownMessage = function () { return (_jsxs(Text, __assign({ size: "body1", display: "flex", alignItems: "center", color: "gray.700" }, { children: [_jsx(Icon, { boxSize: 4, width: "24px", height: "24px", as: VErrorIcon, mr: "2" }), _jsx("span", { children: "Unknown" })] }))); };
